import {
    URLAPI,
    WORK_ACTIVITY_TEMPLATE_CREATE_PATH,
    WORK_ACTIVITY_TEMPLATE_UPDATE_PATH,
    WORK_ACTIVITY_TEMPLATE_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _create_work_activity_template: {
        data: {},
        status: 0,
        message: {},
    },
    _update_work_activity_template: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_work_activity_template: {
        data: {},
        status: 0,
        message: {},
    },
};

export const CREATE_WORK_ACTIVITY_TEMPLATE = "CREATE_WORK_ACTIVITY_TEMPLATE";
export const UPDATE_WORK_ACTIVITY_TEMPLATE = "UPDATE_WORK_ACTIVITY_TEMPLATE";
export const DELETE_WORK_ACTIVITY_TEMPLATE = "DELETE_WORK_ACTIVITY_TEMPLATE";

export const work_activity_templates_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_WORK_ACTIVITY_TEMPLATE:
            return {
                ...state,
                _create_work_activity_template: action.payload,
            };
        case UPDATE_WORK_ACTIVITY_TEMPLATE:
            return {
                ...state,
                _update_work_activity_template: action.payload,
            };
        case DELETE_WORK_ACTIVITY_TEMPLATE:
            return {
                ...state,
                _delete_work_activity_template: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const createWorkActivityTemplate = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${WORK_ACTIVITY_TEMPLATE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_WORK_ACTIVITY_TEMPLATE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_WORK_ACTIVITY_TEMPLATE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_WORK_ACTIVITY_TEMPLATE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateWorkActivityTemplate = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${WORK_ACTIVITY_TEMPLATE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_WORK_ACTIVITY_TEMPLATE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_WORK_ACTIVITY_TEMPLATE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_WORK_ACTIVITY_TEMPLATE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteWorkActivityTemplate = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(`${URLAPI}${WORK_ACTIVITY_TEMPLATE_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_WORK_ACTIVITY_TEMPLATE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_WORK_ACTIVITY_TEMPLATE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_WORK_ACTIVITY_TEMPLATE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const clear_work_activity_template = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
